import sha1 from 'sha1';
import md5 from 'md5';
import { AuthProvider_HashType } from '@finam/txservices-auth/proto';

var hashWith = function hashWith(value, hashType) {
  switch (hashType) {
    case AuthProvider_HashType.SHA1:
      return sha1(value);

    case AuthProvider_HashType.MD5:
      return md5(value);

    default:
      return value;
  }
};

export default hashWith;